import React from 'react';

export function TermsContent() {
  return (
    <>
      <p className="legal-date">Ostatnia aktualizacja: 16 marca 2026</p>
      {[
        { title: '§1 Postanowienia ogólne', items: ['Aplikacja VROOM jest udostępniana przez VROOM.APP (dalej: „Operator").', 'Korzystanie z Aplikacji oznacza akceptację niniejszego Regulaminu.', 'Regulamin obowiązuje od dnia 01.01.2026.'] },
        { title: '§2 Rejestracja i konto', items: ['Do korzystania z pełnej funkcjonalności wymagane jest założenie konta.', 'Użytkownik zobowiązuje się podać prawdziwe dane podczas rejestracji.', 'Użytkownik jest odpowiedzialny za bezpieczeństwo swojego hasła.', 'Jedno konto przypisane jest do jednej osoby fizycznej.', 'Operator zastrzega sobie prawo do usunięcia konta naruszającego Regulamin.'] },
        { title: '§3 Zasady korzystania', items: ['Użytkownik zobowiązuje się korzystać z Aplikacji zgodnie z prawem.', 'Zabrania się publikowania treści obraźliwych, podszywania się pod inne osoby, używania botów.', 'W społeczności (dyskusje, czaty, kluby, profil) obowiązuje zerowa tolerancja dla treści obraźliwych, wulgarnych, nękających, dyskryminujących oraz zachowań agresywnych wobec innych użytkowników. Operator może usuwać takie treści i ograniczać lub usuwać konta naruszające Regulamin.'] },
        { title: '§4 Lokalizacja i dane GPS', items: ['Aplikacja korzysta z GPS wyłącznie za zgodą Użytkownika.', 'Użytkownik może wyłączyć lokalizację w ustawieniach w każdej chwili.'] },
        { title: '§5 Treści użytkowników (UGC)', items: ['Użytkownik może dodawać zdjęcia, komentarze, posty w dyskusjach, wiadomości w czatach i inne treści generowane przez użytkowników.', 'W Aplikacji dostępne są mechanizmy zgłaszania niewłaściwych treści oraz blokowania innych użytkowników (treści zablokowanej osoby znikają z feedu i czatów).', 'Operator rozpatruje zgłoszenia w ciągu 24 godzin: usuwa naruszające treści i może zawiesić lub usunąć konto sprawcy.', 'Operator zastrzega sobie prawo do usunięcia treści naruszających Regulamin bez uprzedzenia.'] },
        { title: '§6 Odpowiedzialność', items: ['Operator nie ponosi odpowiedzialności za treści publikowane przez Użytkowników.', 'Korzystanie z Aplikacji podczas jazdy odbywa się na własne ryzyko Użytkownika.'] },
        { title: '§7 Kontakt', items: ['W sprawach dotyczących Regulaminu: kontakt.vroomapp@gmail.com'] },
      ].map(s => (
        <div key={s.title} className="legal-section">
          <h3>{s.title}</h3>
          {s.items.map((item, i) => <p key={i}>{i + 1}. {item}</p>)}
        </div>
      ))}
    </>
  );
}

function PrivacyContent() {
  return (
    <>
      <p className="legal-date">Ostatnia aktualizacja: 11 maja 2026</p>
      <div className="legal-section">
        <h3>§1 Administrator danych</h3>
        <p>Administratorem danych jest zespół VROOM. Kontakt: <a href="mailto:kontakt.vroomapp@gmail.com">kontakt.vroomapp@gmail.com</a></p>
      </div>
      <div className="legal-section">
        <h3>§2 Jakie dane zbieramy</h3>
        <ul>
          <li><strong>Dane rejestracyjne:</strong> e-mail, nazwa użytkownika, hasło (zaszyfrowane)</li>
          <li><strong>Dane aktywności:</strong> kilometry, odwiedzone miasta, osiągnięcia</li>
          <li><strong>Treści użytkownika:</strong> zdjęcia spotów, komentarze, dane garażu</li>
        </ul>
      </div>
      <div className="legal-section">
        <h3>§3 Dane o lokalizacji urządzenia (LOCATION / GPS)</h3>
        <p>
          <strong>Location data disclosure (English):</strong> The VROOM mobile application accesses
          location data from your device (including precise GPS coordinates when you grant permission).
          This includes location used in the foreground and, if you enable the relevant options in the
          app or system settings, location collected while the app runs in the background for driving
          statistics and similar features.
        </p>
        <p>
          <strong>Ujawnienie (PL):</strong> Aplikacja mobilna VROOM uzyskuje dostęp do danych o lokalizacji
          urządzenia (w tym <strong>współrzędnych GPS</strong> — lokalizacji <strong>dokładnej / precyzyjnej</strong>)
          po uzyskaniu uprawnień w systemie (Android / iOS) oraz — w zakresie wybranych funkcji — po włączeniu
          opcji w aplikacji.
        </p>
        <ul>
          <li><strong>Mapa i nawigacja:</strong> pozycja na mapie, trasy, dopasowanie do drogi (snap).</li>
          <li><strong>Tryb jazdy / statystyki:</strong> zapis przejazdu i dystansu, także przy śledzeniu w tle, jeśli włączone.</li>
          <li><strong>Live Map:</strong> po włączeniu współrzędne mogą być przesyłane na serwer i pokazywane innym użytkownikom.</li>
          <li><strong>Dostawcy (np. Mapbox):</strong> ograniczone dane geolokalizacyjne przekazywane przy żądaniach map / tras.</li>
          <li><strong>Cofnięcie zgody:</strong> w ustawieniach systemu lub aplikacji — część funkcji może być niedostępna.</li>
        </ul>
      </div>
      <div className="legal-section">
        <h3>§4 Cel przetwarzania</h3>
        <ul>
          <li>Świadczenie usług Aplikacji (nawigacja, Live Map, rankingi)</li>
          <li>Wysyłka newslettera (tylko za zgodą)</li>
          <li>Bezpieczeństwo i zapobieganie nadużyciom</li>
        </ul>
      </div>
      <div className="legal-section">
        <h3>§5 Podstawa prawna (RODO)</h3>
        <ul>
          <li>Art. 6 ust. 1 lit. b — wykonanie umowy</li>
          <li>Art. 6 ust. 1 lit. a — zgoda użytkownika</li>
          <li>Art. 6 ust. 1 lit. f — uzasadniony interes (bezpieczeństwo)</li>
        </ul>
      </div>
      <div className="legal-section">
        <h3>§6 Prawa użytkownika</h3>
        <ul>
          <li>Dostęp, sprostowanie i usunięcie danych</li>
          <li>Ograniczenie przetwarzania i przenoszenie danych</li>
          <li>Wniesienie skargi do Prezesa UODO</li>
        </ul>
        <p>
          Żądania dotyczące danych: <a href="mailto:kontakt.vroomapp@gmail.com">kontakt.vroomapp@gmail.com</a>
        </p>
      </div>
      <div className="legal-section">
        <h3>§7 Retencja i bezpieczeństwo</h3>
        <p>Dane przechowywane przez czas aktywności konta. Po usunięciu kasowane w ciągu 30 dni.</p>
        <p>Komunikacja przez HTTPS. Hasła w postaci hashy (bcrypt).</p>
      </div>
      <div className="legal-section">
        <h3>§8 Kontakt</h3>
        <p>W sprawach prywatności i danych osobowych: <a href="mailto:kontakt.vroomapp@gmail.com">kontakt.vroomapp@gmail.com</a></p>
      </div>
    </>
  );
}

export default function LegalModals({ showTerms, showPrivacy, onCloseTerms, onClosePrivacy }) {
  return (
    <>
      {showTerms && (
        <div className="legal-overlay" onClick={onCloseTerms}>
          <div className="legal-modal" onClick={e => e.stopPropagation()}>
            <div className="legal-header">
              <h2>REGULAMIN <span>VROOM</span></h2>
              <button className="legal-close" onClick={onCloseTerms}>
                <span className="material-icons">close</span>
              </button>
            </div>
            <div className="legal-body"><TermsContent /></div>
          </div>
        </div>
      )}

      {showPrivacy && (
        <div className="legal-overlay" onClick={onClosePrivacy}>
          <div className="legal-modal" onClick={e => e.stopPropagation()}>
            <div className="legal-header">
              <h2>POLITYKA <span>PRYWATNOŚCI</span></h2>
              <button className="legal-close" onClick={onClosePrivacy}>
                <span className="material-icons">close</span>
              </button>
            </div>
            <div className="legal-body"><PrivacyContent /></div>
          </div>
        </div>
      )}
    </>
  );
}